import APIKit from "../Allapis/Apikit/apikit";

export const getRegisteredUsers = async (params = {}) => {
  console.log({ paramssgjsgsgjsgsjgsjgsjg: params });
  const endpoint = `/admin/analytics/graph`;
  const res = await APIKit.get(endpoint, { params });
  console.log({ res: res });
  return res.data;
};
export const getDownloadsData = async (params = {}) => {
  const endpoint = `/admin/analytics/downloads`;
  const res = await APIKit.get(endpoint, { params });
  // console.log({ res: res });
  return res.data;
};
export const getLoginsData = async (params = {}) => {
  const endpoint = `/admin/analytics/history`;
  const res = await APIKit.get(endpoint, { params });
  // console.log({ res: res });
  return res.data;
};
